import moment from "moment-timezone";
import { DEFAULT_TZ } from "intake_shared/src/types";

moment.tz.setDefault(DEFAULT_TZ);

export default moment;
